import { useMediaQuery } from 'react-responsive'
import { devices } from '../utils/responsive'

export function useDevice() {
  const isDesktop = useMediaQuery({ query: `${devices.desktop}` })
  const isDesktopSmall = useMediaQuery({ query: `${devices.desktopSmall}` })
  const isTablet = useMediaQuery({ query: `${devices.tablet}` })
  const isMobile = useMediaQuery({ query: `${devices.mobile}` })
  return { isDesktop, isDesktopSmall, isTablet, isMobile }
}
